export const ROOT_FONT_SIZE = 16;
export const FONT_FAMILIES = {
  primary: 'Montserrat, system-ui, -apple-system, Arial, sans-serif',
  secondary: 'DM Serif Display, serif',
};

export const MIN_WIDTH = 375;
export const MAX_WIDTH = 1400;
